import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { CommonStyledComponentProps } from '__utils/type';
import styled from 'styled-components';
import callNowMan from 'images/call_now_man.svg';
import { SuccessButton } from 'components/button';
import { CallIconWhite } from 'assets/icons/call-icon-white';

const SlabContainer = styled.div`
    background: #E5F6F0;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 12px 16px 0 16px;
    display: flex;
    width: 100%;
    h3{
        font-size: 14px;
        font-weight: 500;
    }

`;

const CallButton = styled(SuccessButton) <CommonStyledComponentProps>`
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 15px;
        line-height: 0;
        width: 94px;
        height:25px;
        font-size: 12px;
        font-weight: normal;
        margin-top: 12px;

`;

const CallNowSlab: React.FC = () => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    return (
        <SlabContainer>
            <div>
                <h3>Need guidance to do Mutual funds business?</h3>
                <a href="tel:18002666468"><CallButton isMobile={ isMobile }><CallIconWhite />&nbsp; Call Now</CallButton></a>
            </div>

            <div style={{paddingLeft:'8px'}}>
                <img src={ callNowMan }></img>
            </div>
        </SlabContainer>
    )
}
export default CallNowSlab;
